/**
 * A komponens típusa — a felületen „Nyomtatott / Vásárolt / Összeépített".
 *
 * A típus a `component`.`kind` oszlopban él. Ez a fájl szándékosan
 * függőségmentes (nincs benne se NestJS, se TypeORM), mert a frontend is
 * innen veszi a típust és a tartalék-következtetést — így a két oldal nem
 * mondhat mást ugyanarról a tételről.
 */
export type ComponentKind = 'printed' | 'bought' | 'assembled';

export const COMPONENT_KINDS: ComponentKind[] = ['printed', 'bought', 'assembled'];

/** A típus sorai, ahogy a felület nevezi őket. */
export const COMPONENT_KIND_LABELS: { [key in ComponentKind]: string } = {
  printed: 'Nyomtatott',
  bought: 'Vásárolt',
  assembled: 'Összeépített',
};

export interface ComponentKindSource {
  kind?: ComponentKind | string | null;
  has_bom?: number | null;
  printing_time?: number | null;
  material_id?: number | null;
}

export function isComponentKind(value: unknown): value is ComponentKind {
  return typeof value === 'string' && (COMPONENT_KINDS as string[]).includes(value);
}

/**
 * Egy komponens típusa.
 *
 * A tárolt `kind` a mérvadó. Tartaléknak megmarad a régi következtetés (van
 * BOM → összeépített; van nyomtatási idő vagy anyag → nyomtatott; egyébként
 * vásárolt), hogy a migráció előtti sorok se essenek ki a listákból.
 */
export function componentKindOf(row: ComponentKindSource | null | undefined): ComponentKind {
  if (!row) {
    return 'bought';
  }
  if (isComponentKind(row.kind)) {
    return row.kind;
  }
  if (Number(row.has_bom) === 1) {
    return 'assembled';
  }
  if ((Number(row.printing_time) || 0) > 0 || (row.material_id !== null && row.material_id !== undefined)) {
    return 'printed';
  }
  return 'bought';
}
